import type { FaireProductEntity } from "../../entity_types/product";

export const p_vaba25wx8e: FaireProductEntity = {
  token: "p_vaba25wx8e",
  type: "product",
  name: "Beef Tallow Potato Chips - Salt N' Pepper",
  brandToken: "b_d6aqh4qdhb",
  brandName: "Beefy's Own",
  imageUrl:
    "https://cdn.faire.com/fastly/5b53b3f8ff6e0beda25238e43e9fd6466b20ad4f3680d3a35a8d88c5ed8ef3f4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8eb3bee459584c781c8ab00f12e6d8a7d3f7d7e7086f216d916b4f7a1c9793dd.png",
    "https://cdn.faire.com/fastly/c4720e3b5a152121234e10e345b04fa6fe0683690f430f4f51fcd40f5b2461e3.png",
    "https://cdn.faire.com/fastly/d1f19b6580eadd6f3b1b9d429adecccd9d0c9410500ebc09dc3eae43c3f50b56.png",
    "https://cdn.faire.com/fastly/e3d0c48f31ae711ec9e873572e7b952663ddf8a3e59bb7f32a5ef1c85a080a66.png",
    "https://cdn.faire.com/fastly/4a7b0fe00cfd15c5cde9d827780060995e201769ddb7a2cc4b61b4683ecc451d.png",
    "https://cdn.faire.com/fastly/ed546a27e007b7182636e6ba6b7b8018db7e5cc0e8cb35295f52e45c0fb6f01c.png",
    "https://cdn.faire.com/fastly/6b7d463da25da302173ec80cdafdf1b9664f904f9eb0b3d251d7895187057e50.png",
  ],
  priceDollars: 6.5,
  description:
    "Perfect, crispy, golden potato chips fried the old-fashioned way in pure beef tallow - bringing back old-school flavor you forgot existed. Our Salt N' Pepper chips hit just right, with the perfect balance of bold black pepper, a hint of onion and garlic, and just the right amount of salt - never overpowering, always just right. Our dedicated team of chip artisans takes pride in ensuring every chip meets the highest standards of taste and texture. From the satisfying crunch to the perfectly seasoned finish, these small-batch chips deliver a snack experience like no other.\n\n-5oz bags-\nNon-GMO Potatoes, Beef Tallow, Sea Salt, Black Pepper, Buttermilk Powder, Garlic Powder, Onion Powder. ",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T21:11:39.437Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
